import { ConfigProvider, ConfigProviderProps } from "antd";
import { ReactNode } from "react";

export function ThemeProvider({
  children,
  theme,
}: {
  children: ReactNode;
  theme: ConfigProviderProps["theme"];
}) {
  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
}
